<template>
  <v-dialog v-model="visible" persistent max-width="400" width="100%">
    <v-card class="rounded-16">
      <v-card-text class="text-center pt-6 pb-2">
        <v-avatar color="primary" size="56" class="mb-3">
          <v-icon color="white" size="30">mdi-bell-ring</v-icon>
        </v-avatar>
        <div class="text-h6 font-weight-bold mb-2">開啟通知，掌握第一手消息</div>
        <div class="text-body-2 text--secondary">
          開啟後即可即時收到訂單、佣金、推薦等重要通知。<br />可隨時到系統設定關閉。
        </div>
      </v-card-text>
      <v-card-actions class="justify-center pb-6 px-6">
        <v-btn text :disabled="working" @click="later">稍後再說</v-btn>
        <v-btn color="primary" :loading="working" @click="accept">開啟通知</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  isNativeApp,
  getPushPermissionState,
  initPush,
  ensurePushRegistered,
  watchPushPermissionOnResume,
  resetPushRegistration,
} from "@/utils/push";

const DISMISS_KEY = "push_prompt_dismissed_at";
const COOLDOWN_DAYS = 7;

export default {
  name: "PushPermissionDialog",
  data() {
    return {
      visible: false,
      working: false,
      evaluated: false,
    };
  },
  computed: {
    signedIn() {
      return this.$store.state.signinStatus;
    },
  },
  watch: {
    signedIn(val) {
      if (val) {
        this.evaluate();
      } else {
        // 登出：換帳號登入時要重新判斷、重新把 token 綁到新帳號
        this.evaluated = false;
        resetPushRegistration();
      }
    },
  },
  mounted() {
    // 從系統設定回到 App 時重新檢查、權限一開就自動註冊（不用重開 App）
    watchPushPermissionOnResume();
    this.evaluate();
  },
  methods: {
    async evaluate() {
      if (this.evaluated) return;
      if (!isNativeApp()) return;
      if (!this.signedIn) return; // 等登入後再處理
      this.evaluated = true;

      let state;
      try {
        state = await getPushPermissionState();
      } catch (e) {
        return;
      }

      if (state === "granted") {
        // 已授權 → 靜默註冊 token，不打擾
        ensurePushRegistered().catch(() => {});
        return;
      }

      if (state === "prompt" || state === "prompt-with-rationale") {
        // 冷卻期內不再詢問（按過「稍後」的話）
        const last = parseInt(localStorage.getItem(DISMISS_KEY) || "0", 10);
        const cooldownMs = COOLDOWN_DAYS * 24 * 60 * 60 * 1000;
        if (last && Date.now() - last < cooldownMs) return;
        this.visible = true;
      }
      // denied → 不再跳這個對話框。通知中心最上方的設定卡會提供「前往系統設定開啟」
    },
    async accept() {
      this.working = true;
      try {
        await initPush(); // 觸發系統權限請求 + 註冊 token
      } catch (e) {
        // 使用者可能仍拒絕，忽略
      }
      this.working = false;
      this.visible = false;
    },
    later() {
      localStorage.setItem(DISMISS_KEY, String(Date.now()));
      this.visible = false;
    },
  },
};
</script>
